import { CLOSE_WEBSOCKET_CONNECTION, OPEN_WEBSOCKET_CONNECTION } from './actionTypes';

export const openWebsocketConnection = () => ({ type: OPEN_WEBSOCKET_CONNECTION });
export const closeWebsocketConnection = () => ({ type: CLOSE_WEBSOCKET_CONNECTION });
